<template>
  <el-form-item
    :label="title"
    :rules="[{required: isRequire, message: 'Please enter', trigger: 'blur'}]"
  >
    <el-select
      v-model="value"
      :disabled="disabled"
      filterable
      :autocomplete="autocomplete"
      :placeholder="placeholder"
      :style="{width: width +'px'}"
    >
      <el-option
        v-for="item in items"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :disabled="item.disabled || false"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { parse, save } from '../providers/store-parser'

export default {
  name: 'InputSelect',
  props: {
    title: {
      type: String,
      required: true
    },
    getter: {
      type: String,
      required: true
    },
    setter: {
      type: String,
      required: true
    },
    options: {
      type: String,
      required: true
    },
    defaultValue: {
      type: [String, Number],
      required: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    isRequire: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 200
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created () {
    if (this.defaultValue > 0) {
      save(this.setter, this.defaultValue)
    }
  },
  computed: {
    value: {
      get () {
        return parse(this.getter) || this.defaultValue
      },
      set (val) {
        save(this.setter, val)
        this.$emit('select-changed', val)
      }
    },
    items () {
      return parse(this.options)
    }
  }
}
</script>
